module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/card_corner_xN.8828c7bd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/card_corner_xN.png
// module id = 2954
// module chunks = 11